export const ERROR_CODE_EXPIRED = 101 // 活动过期
export const ERROR_CODE_GONE = 102 // 领光了
export const ERROR_CODE_LIMIT = 103 // 领取次数达到上限
export const ERROR_CODE_GENERAL = 201 // 通用错误码
export const STATUE_SUCCESS = 1 // 领取成功
export const STATUE_RECEIVED = 2 // 已经领取过
export const STATUE_FAIL = 3 // 领取失败
export const PHONE_NUMBER_EMPTY = 1 // 手机号为空
export const PHONE_NUMBER_ERROR = 2 // 手机号格式错误
export const NOT_CHECKED_P = 3 // 未勾选协议
